export function getTrackerUrl(taskKey: string): string {
  return `https://tracker.yandex.ru/${taskKey}`;
}
